import React from 'react';

function GoogleFitPanel({
  fitCollapsed,
  fitConnected,
  fitLoading,
  fitError,
  fitSteps,
  fitHeartRate,
  fitRestingHeartRate,
  fitLastSyncedAt,
  suggestedStepGoal,
  onToggleCollapsed,
  onConnect,
  onRefresh,
}) {
  return (
    <div className={`google-fit-card ${fitCollapsed ? 'collapsed' : ''}`}>
      <div className="google-fit-header">
        <h3>Google Fit</h3>
        <div className="google-fit-actions">
          <button
            type="button"
            className="google-fit-toggle"
            onClick={onToggleCollapsed}
            aria-expanded={!fitCollapsed}
          >
            {fitCollapsed ? 'Expand' : 'Collapse'}
          </button>
          {!fitConnected ? (
            <button
              className="google-fit-btn"
              onClick={onConnect}
              disabled={fitLoading || Boolean(fitError)}
            >
              {fitLoading ? 'Connecting...' : 'Connect'}
            </button>
          ) : (
            <button
              className="google-fit-btn"
              onClick={onRefresh}
              disabled={fitLoading}
            >
              {fitLoading ? 'Refreshing...' : 'Refresh'}
            </button>
          )}
        </div>
      </div>

      {!fitCollapsed && (
        <>
          {fitError && <div className="google-fit-error">{fitError}</div>}

          <div className="google-fit-metrics">
            <div className="fit-metric">
              <span className="fit-label">Steps</span>
              <span className="fit-value">{fitSteps ?? '--'}</span>
            </div>
            <div className="fit-metric">
              <span className="fit-label">Heart Rate</span>
              <span className="fit-value">{fitHeartRate ? `${fitHeartRate} bpm` : '--'}</span>
            </div>
            <div className="fit-metric">
              <span className="fit-label">Resting HR</span>
              <span className="fit-value">{fitRestingHeartRate ? `${fitRestingHeartRate} bpm` : '--'}</span>
            </div>
            <div className="fit-metric">
              <span className="fit-label">Suggested Goal</span>
              <span className="fit-value">{suggestedStepGoal.toLocaleString()} steps</span>
            </div>
          </div>
          {fitLastSyncedAt && (
            <p className="settings-note">Last synced: {new Date(fitLastSyncedAt).toLocaleString()}</p>
          )}
        </>
      )}
    </div>
  );
}

export default GoogleFitPanel;
